export enum ENUM__field_graph_interaction {
  VISIBLE_NON_CONNECTABLE = 'VISIBLE_NON_CONNECTABLE',
  VISIBLE_CONNECTABLE = 'VISIBLE_CONNECTABLE',
  HIDDEN = 'HIDDEN',
}
